export default "__VITE_ASSET__DY$BpLql__"